module.exports = __webpack_public_path__ + "img/logout-active.8535d354.svg";